import { CorrectiveActionService } from '../services/CorrectiveActionService';

export function useCorrectiveActionService(): CorrectiveActionService {
  return new CorrectiveActionService(useApiClient(), useUserStore());
}
